<div class="solver-container mx-auto flex max-w-2xl flex-col gap-4 p-8">
  <dojo-solver [solver]="derivativeSolver" />
  <dojo-solver [solver]="quadraticSolver" />
</div>
